import { api } from './configs/axiosConfig';
export const FeedbackAPI = {
    submitFeedback: async function (feedbackData) {
        const response = await api.post(`${process.env.REACT_APP_API_URL}/feedback`, feedbackData, {
            // Skip the global error toast for feedback
            skipErrorToast: true
        });
        return response?.data;
    }
};
